// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"17":"extractos","43":"cuenta","246":"prestamo","530":"plazofijo","737":"facturacredito","788":"becas"}[chunkId] + "." + {"17":"a7aa87ab","43":"d756b1a7","246":"9585cc31","530":"33db59cf","737":"b1d4850a","788":"300c2797"}[chunkId] + ".css";
};